import React from "react";
import { cityCount, tutorCount, userCount } from "../../../utils/constants";

const Reach = () => {
  return (
    <div className="Reach">
      <div className="Reach__content">
        <p className="Reach__content-value">{cityCount ?? "2,300"}+</p>
        <p className="Reach__content-text">Cities</p>
      </div>
      <div className="Reach__content">
        <p className="Reach__content-value"> {tutorCount ?? "1 Lakh"}+</p>
        <p className="Reach__content-text">Teachers</p>
      </div>
      <div className="Reach__content">
        <p className="Reach__content-value">{userCount ?? "1 Crore"}+</p>
        <p className="Reach__content-text"> Students</p>
      </div>
    </div>
  );
};

export default Reach;
